/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2018 Deere & Company

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

const ModalHeader = (props) => (
    <header>
        <span>
            <FormattedMessage id={props.modalTitle} />
        </span>
        <span
            className="close-modal-icon"
            onClick={props.onCloseButtonClick}
        />
    </header>
);

ModalHeader.displayName = 'ModalHeader';
ModalHeader.propTypes = {
    modalTitle: PropTypes.string.isRequired,
    onCloseButtonClick: PropTypes.func.isRequired,
};

export default ModalHeader;
